import { render, staticRenderFns } from "./FrequentlyTruckingTable.vue?vue&type=template&id=c98b57fc&scoped=true&"
import script from "./FrequentlyTruckingTable.vue?vue&type=script&lang=js&"
export * from "./FrequentlyTruckingTable.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyTruckingTable.vue?vue&type=style&index=0&id=c98b57fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98b57fc",
  null
  
)

export default component.exports